module.exports = __webpack_public_path__ + "img/Mask Group 15.98622b37.png";